import { fetch } from '@atlassian/eoc-fetch';

import { withAIOpsDomainPrefix } from '../../../../common/utils';
import { type CompressionRatioResponse } from '../types';

export const getCompressionRatio = () => {
	return fetch<CompressionRatioResponse>(
		withAIOpsDomainPrefix('/v1/alert-insights/compression-ratio'),
		{
			exactUrl: true,
		},
	);
};
